import React, { useState } from 'react'
import Search from './Search'
import Menu from './Menu'
import { Link } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu';

const Header = () => {
  const[isMenuOpen,setIsMenuOpen]=useState(false);
  return (
    <>
      <div className="header bg-transparent h-[80px] leading-6 flex  items-center justify-center space-x-4 px-[4px] shadow-lg md:justify-evenly" style={{backgroundColor:''}}>
            <Link to='/'>
              <div className="logo ">
                  <div className='font-extrabold text-[20px] text-white italic md:text-[50px] '>
                    <span className='text-pink-600'>Shop</span>
                    <span className='text-purple-600'>33</span>
                  </div>
                  <div className='text-black text-[12px] hidden md:visible'>Newness everywhere</div>
              </div>
            </Link>
            <div className='hidden md:block'>
              <Menu/>
            </div>
            <Search/>
            <div className={`block md:hidden ${isMenuOpen? 'bg-pink-300 rounded-[50%] p-[4px]' : ''}`}>
              <MenuIcon style={{color:'#d64089'}} onClick={()=>{setIsMenuOpen(!isMenuOpen)}}/>
            </div>
            {
              isMenuOpen &&
              <div className='absolute top-[80px] right-[0px] bg-slate-100 z-100 px-[20px] py-[20px]'>
                <Menu/>
              </div>
            }
            
      </div>
    </>
  )
}

export default Header
